import client from "./client";

export const fetchChainControl = (routeSlug) => client.get(`/traffic/${routeSlug}`).then((r) => r.data);
